export enum PolicyType {
  Custom = 'Custom',
  Default = 'Default',
  None = 'None'
}

export enum PolicyTypeExtended {
  All = 'All',
  Custom = PolicyType.Custom,
  Default = PolicyType.Default,
  None = PolicyType.None
}
